import { doc, getDoc, setDoc, serverTimestamp } from 'firebase/firestore';
import { firestore } from '../firebase';

const DEFAULT_REGISTRATION_URL = 'https://fury-registration.web.app';

/**
 * Site-wide registration flags (document site/settings).
 * @returns {Promise<{ registrationOpen: boolean, registrationUrl: string, interestListUrl: string }>}
 */
export async function fetchSiteRegistrationSettings() {
  try {
    const snap = await getDoc(doc(firestore, 'site', 'settings'));
    const d = snap.exists() ? snap.data() : {};
    const open = d.registrationOpen === true;
    const registrationUrl =
      typeof d.registrationUrl === 'string' && d.registrationUrl.trim()
        ? d.registrationUrl.trim()
        : DEFAULT_REGISTRATION_URL;
    const interestListUrl =
      typeof d.interestListUrl === 'string' && d.interestListUrl.trim()
        ? d.interestListUrl.trim()
        : '';
    return { registrationOpen: open, registrationUrl, interestListUrl };
  } catch {
    return {
      registrationOpen: false,
      registrationUrl: DEFAULT_REGISTRATION_URL,
      interestListUrl: '',
    };
  }
}

/**
 * Site-wide registration gate (marketing / schedule CTA).
 * @param {boolean} open
 */
export async function saveSiteRegistrationOpen(open) {
  await setDoc(
    doc(firestore, 'site', 'settings'),
    { registrationOpen: !!open, updatedAt: serverTimestamp() },
    { merge: true }
  );
}
